import { createSelector } from "@reduxjs/toolkit";
import ReduxState from "../models";

export const getUser = (state: ReduxState) => state.user;

export const getUserId = createSelector(getUser, u => (u as any)?._id);
export const getWorkspace = createSelector(getUser, user => user?.workspace);
export const getLocationDrafts = createSelector(getWorkspace, w => w.drafts?.locations);
